(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-content"] && !Shopify.designMode) return;
  try {
    
(function () {
  function isHeading(el) { return /^H[3-6]$/.test(el.tagName); }
  function isBoldQuestion(el) {
    if (el.tagName !== 'P') return false;
    var b = el.querySelector('strong, b');
    return !!b && b.textContent.trim() === el.textContent.trim() && el.textContent.trim().length > 0;
  }
  function isImageOnly(el) {
    if (el.tagName === 'IMG' || el.tagName === 'FIGURE') return true;
    if (el.tagName !== 'P' && el.tagName !== 'DIV') return false;
    return !!el.querySelector('img') && el.textContent.trim() === '';
  }

  function buildFaq(block, h2, items, faqs) {
    var wrap = document.createElement('div');
    wrap.className = 'mfc-faq__list';
    var current = null;
    items.forEach(function (el) {
      if (isHeading(el) || isBoldQuestion(el)) {
        current = document.createElement('details');
        current.className = 'mfc-q';
        var sum = document.createElement('summary');
        sum.appendChild(el);
        var icon = document.createElement('span');
        icon.className = 'mfc-q__icon';
        icon.setAttribute('aria-hidden', 'true');
        sum.appendChild(icon);
        var ans = document.createElement('div');
        ans.className = 'mfc-q__a';
        current.appendChild(sum);
        current.appendChild(ans);
        wrap.appendChild(current);
        faqs.push({ q: el, a: ans });
      } else if (current) {
        current.querySelector('.mfc-q__a').appendChild(el);
      } else {
        wrap.appendChild(el);
      }
    });
    var first = wrap.querySelector('details');
    if (first) first.open = true;
    block.classList.add('mfc-faq');
    block.appendChild(h2);
    block.appendChild(wrap);
  }

  function buildCards(block, h2, items) {
    block.appendChild(h2);
    var h3count = items.filter(function (el) { return el.tagName === 'H3'; }).length;
    if (h3count < 2) { items.forEach(function (el) { block.appendChild(el); }); return; }
    var grid = null, card = null;
    items.forEach(function (el) {
      if (el.tagName === 'H3') {
        if (!grid) { grid = document.createElement('div'); grid.className = 'mfc-cards'; block.appendChild(grid); }
        card = document.createElement('div');
        card.className = 'mfc-card';
        grid.appendChild(card);
        card.appendChild(el);
      } else if (card) {
        card.appendChild(el);
      } else {
        block.appendChild(el);
      }
    });
  }

  function addImage(block, media, flip) {
    if (!media) return;
    var grid = block.querySelector('.mfc-cards');
    if (grid) {
      media.classList.add('mfc-media--banner');
      block.insertBefore(media, grid);
      return;
    }
    var split = document.createElement('div');
    split.className = 'mfc-split';
    var text = document.createElement('div');
    text.className = 'mfc-split__text';
    while (block.firstChild) text.appendChild(block.firstChild);
    split.appendChild(text);
    split.appendChild(media);
    block.appendChild(split);
    if (flip) block.classList.add('mfc-block--flip');
  }

  function enhance(root) {
    if (root.dataset.mfcReady) return;
    root.dataset.mfcReady = '1';
    var body = root.querySelector('[data-mfc-body]');
    if (!body) return;

    var imgTpl = root.querySelector('template[data-mfc-images]');
    var metaImages = [];
    if (imgTpl) {
      Array.prototype.forEach.call(imgTpl.content.querySelectorAll('.mfc-media'), function (fig) {
        metaImages.push(document.importNode(fig, true));
      });
    }

    var children = Array.prototype.slice.call(body.children);
    var groups = [], lead = [], cur = null;
    children.forEach(function (el) {
      if (el.tagName === 'H2' || el.tagName === 'H1') { cur = { h: el, items: [] }; groups.push(cur); }
      else if (cur) cur.items.push(el);
      else lead.push(el);
    });

    body.innerHTML = '';
    var contentBlocks = [], faqBlocks = [], faqs = [];

    if (lead.length) {
      var lb = document.createElement('div');
      lb.className = 'mfc-block mfc-block--lead';
      lead.forEach(function (el) { lb.appendChild(el); });
      contentBlocks.push(lb);
    }

    var cardBlocks = 0, imgIndex = 0;
    groups.forEach(function (g) {
      var block = document.createElement('div');
      block.className = 'mfc-block';
      if (g.h.tagName === 'H1') {
        var h2 = document.createElement('h2');
        h2.innerHTML = g.h.innerHTML;
        g.h = h2;
      }

      if (/faq/i.test(g.h.textContent)) {
        buildFaq(block, g.h, g.items, faqs);
        faqBlocks.push(block);
        return;
      }

      // an image placed right under the H2 in the description editor
      var inlineMedia = null;
      if (g.items.length && isImageOnly(g.items[0])) {
        var imgEl = g.items.shift();
        inlineMedia = document.createElement('figure');
        inlineMedia.className = 'mfc-media';
        inlineMedia.appendChild(imgEl.tagName === 'IMG' ? imgEl : (imgEl.querySelector('img') || imgEl));
      }

      buildCards(block, g.h, g.items);
      var hasCards = !!block.querySelector('.mfc-cards');
      if (hasCards) {
        cardBlocks++;
        if (cardBlocks % 2 === 0) block.classList.add('mfc-block--dark');
      }

      var media = inlineMedia || metaImages[imgIndex] || null;
      if (media) {
        addImage(block, media, imgIndex % 2 === 1);
      }
      imgIndex++;
      contentBlocks.push(block);
    });

    // content (collapsible) first, FAQ after it — FAQ is never hidden
    var collapse = document.createElement('div');
    collapse.className = 'mfc-collapse';
    collapse.id = root.id + '-more';
    contentBlocks.forEach(function (b) { collapse.appendChild(b); });
    body.appendChild(collapse);

    var moreWrap = null;
    if (root.dataset.collapse === 'true' && contentBlocks.length) {
      var limit = parseInt(getComputedStyle(root).getPropertyValue('--mfc-h'), 10) || 650;
      if (collapse.scrollHeight > limit + 120) {
        collapse.classList.add('is-collapsed');
        moreWrap = document.createElement('div');
        moreWrap.className = 'mfc-more';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mfc-more__btn';
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-controls', collapse.id);
        var label = document.createElement('span');
        label.textContent = root.dataset.more || 'Read more';
        btn.appendChild(label);
        btn.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>');
        btn.addEventListener('click', function () {
          var open = collapse.classList.toggle('is-collapsed') === false;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          label.textContent = open ? (root.dataset.less || 'Show less') : (root.dataset.more || 'Read more');
          if (!open) collapse.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        moreWrap.appendChild(btn);
        body.appendChild(moreWrap);
      }
    }

    faqBlocks.forEach(function (b) { body.appendChild(b); });

    if (root.dataset.faqSchema === 'true' && faqs.length) {
      var data = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map(function (f) {
          return { '@type': 'Question', name: f.q.textContent.trim(), acceptedAnswer: { '@type': 'Answer', text: f.a.textContent.trim() } };
        })
      };
      var s = document.createElement('script');
      s.type = 'application/ld+json';
      s.textContent = JSON.stringify(data);
      document.head.appendChild(s);
    }
  }

  function run() { document.querySelectorAll('[data-mfc]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  tabs= document.querySelectorAll('.custom-tab');
  tabContents= document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function(tab){
      tab.addEventListener('click',function(){

          contentId = this.dataset.contentId;
          content = document.getElementById(contentId);

          tabContents.forEach(function(content){
              content.classList.remove('active');
          });

          tabs.forEach(function(tab){
              tab.classList.remove('active');
          });

          this.classList.add('active');
          content.classList.add('active');
      });
  });

  } catch(e) { console.error(e); }
})();
})();
